import Vue from "vue";
import VueRouter from "vue-router";
import MapView from "../views/MapView";
import { firebaseAuth } from "@/firebase";

Vue.use(VueRouter);

const routes = [
    {
        path: "/login",
        name: "Login",
        meta: {
            requiresAuth: false
        },
        component: () => import("../views/Login.vue")
    },
    {
        path: "/logout",
        name: "Logout",
        meta: {
            requiresAuth: false
        },
        component: () => import("../views/Logout.vue")
    },
    {
        path: "/",
        name: "Map",
        component: MapView,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/register-vehicle",
        name: "Register vehicle",
        meta: {
            requiresAuth: true
        },
        component: () => import("../views/RegisterVehicleView.vue")
    }
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes
});

router.beforeEach(async (to, from, next) => {
    const isLoggedIn = await getCurrentUser();
    if (to.matched.some(record => record.meta.requiresAuth) && !isLoggedIn)
        next('/login')
    else if (to.matched.some(record => record.name === 'Login') && isLoggedIn)
        next('/')
    else next();
})

// Can't be retrieved from Vuex store due to the lifecycle of router. Might not be set just yet
function getCurrentUser() {
    return new Promise ((resolve, reject) => {
        const unsubscribe = firebaseAuth.onAuthStateChanged(user => {
            unsubscribe();
            resolve(user);
        }, reject)
    });
}

export default router;
